export type ButtonStyle =
    'Default' |
    'Secondary' |
    'Bordered';

export class ButtonStyles {
    public static readonly DEFAULT: ButtonStyle = 'Default';
    public static readonly SECONDARY: ButtonStyle = 'Secondary';
    public static readonly BORDERED: ButtonStyle = 'Bordered';
}
